/*
 * MINDELOR footer boundary
 * Stops outward gestures at the public footer without trapping nested scrollers.
 */
(() => {
  const hasPublicFooter = document.body.dataset.mindelorBottomSurface === 'footer';

  const bottomTolerance = 1;
  let trackingGesture = false;
  let startX = 0;
  let startY = 0;
  let previousY = 0;

  const pageBottom = () => {
    const root = document.scrollingElement || document.documentElement;
    return Math.max(0, root.scrollHeight - window.innerHeight);
  };

  const isZoomed = () => window.visualViewport && window.visualViewport.scale !== 1;

  const nestedScrollerHandlesGesture = (event) => event.composedPath().some((element) => {
    if (!(element instanceof Element) || element === document.body || element === document.documentElement) return false;

    const style = getComputedStyle(element);
    if (!/(auto|scroll)/.test(style.overflowY) || element.scrollHeight <= element.clientHeight) return false;

    return element.scrollTop + element.clientHeight < element.scrollHeight - bottomTolerance ||
      style.overscrollBehaviorY === 'contain' || style.overscrollBehaviorY === 'none';
  });

  const stopAtFooter = (event, distance) => {
    if (!event.cancelable || isZoomed() || distance <= 0 || nestedScrollerHandlesGesture(event)) return;

    const bottom = pageBottom();
    const remaining = bottom - window.scrollY;
    if (remaining > distance + bottomTolerance) return;

    event.preventDefault();
    // Preserve the last part of a gesture that reaches the boundary.
    if (Math.abs(remaining) > bottomTolerance) window.scrollTo({ top: bottom, behavior: 'instant' });
  };

  document.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1) {
      trackingGesture = false;
      return;
    }

    const touch = event.touches[0];
    trackingGesture = true;
    startX = touch.clientX;
    startY = touch.clientY;
    previousY = touch.clientY;
  }, { passive: true, capture: true });

  const handleTouchMove = (event) => {
    if (!trackingGesture || event.touches.length !== 1) return;

    const touch = event.touches[0];
    const horizontalDistance = Math.abs(touch.clientX - startX);
    const verticalDistance = Math.abs(touch.clientY - startY);
    const movingUpward = touch.clientY < previousY;
    const distance = previousY - touch.clientY;
    previousY = touch.clientY;

    if (
      verticalDistance > horizontalDistance &&
      movingUpward
    ) {
      if (hasPublicFooter) {
        stopAtFooter(event, distance);
      } else {
        // Preserve the existing touch boundary outside the public footer.
        const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        if (window.scrollY + window.innerHeight >= documentHeight - 2) event.preventDefault();
      }
    }
  };

  window.addEventListener('touchmove', handleTouchMove, {
    passive: false,
    capture: true
  });

  if (hasPublicFooter) {
    window.addEventListener('wheel', (event) => {
      if (event.ctrlKey || event.metaKey || event.deltaY <= Math.abs(event.deltaX)) return;

      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1;
      stopAtFooter(event, event.deltaY * unit);
    }, { passive: false, capture: true });
  }

  document.addEventListener('touchend', () => {
    trackingGesture = false;
  }, { passive: true, capture: true });

  document.addEventListener('touchcancel', () => {
    trackingGesture = false;
  }, { passive: true, capture: true });
})();
